
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 5h18c1.645 0 3 1.355 3 3v1h1c1.645 0 3 1.355 3 3v12c0 1.645-1.355 3-3 3H9c-1.645 0-3-1.355-3-3v-1H5c-1.645 0-3-1.355-3-3V8c0-1.645 1.355-3 3-3zm0 2c-.565 0-1 .435-1 1v12c0 .565.435 1 1 1h18c.565 0 1-.435 1-1v-9H5V9h19V8c0-.565-.435-1-1-1H5zm21 4v2h2v-1c0-.565-.435-1-1-1h-1zm0 4v5c0 1.645-1.355 3-3 3H8v1c0 .565.435 1 1 1h18c.565 0 1-.435 1-1v-9h-2z"}})])
          )
        }
      }
    